<template>
    <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
        <v-card>
            <!-- Zig Zag seperator -->
            <div class="mb-4">
                <zigZag></zigZag>
            </div>
            <!-- Container -->
            <v-layout text-xs-center>
                <v-flex mb-0 xs12 mx-2>
                    <v-layout justify-start row mx-3 mt-0 align-center>
                        <v-flex v-if="formType=='create'">
                            <v-layout row >
                                <v-icon class="mr-2">fa-plus-circle</v-icon>
                                <div class="text-xs-left" style="font-size: 20px; font-weight: 600;">
                                    Create New User
                                </div>
                            </v-layout>
                        </v-flex>
                        <v-flex>
                            <v-layout row>
                                <v-flex>
                                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                                        <v-btn icon @click="cancel" class="pa-0 mr-0">
                                            <v-icon>fa-times</v-icon>
                                        </v-btn>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                    <v-flex mb-0 xs12 mx-2 v-if="formType!=='view'">
                        <v-layout justify-start row mx-3 mt-0 align-center v-if="formType=='edit'">
                            <v-icon class="mr-2">fa-plus-circle</v-icon>
                            <div class="text-xs-left" style="font-size: 20px; font-weight: 600;">
                                Edit User
                            </div>
                        </v-layout>

                        <v-form v-model="valid"
                                @submit="createUser"
                                ref="createUserForm">
                            <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                                <v-layout hide-details justify-start row mt-0 mb-0>
                                    <v-flex hide-details mx-4 xs3>
                                        <v-text-field
                                            v-model="user.Username"
                                            label="Username"
                                            :disabled="isUsernameDisabled"
                                            single-line
                                            :rules="emailRules"
                                            required
                                            >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex  hide-details mx-4 xs3>
                                        <v-text-field
                                            v-model="user.FirstName"
                                            label="First Name"
                                            single-line
                                            clearable
                                            :rules="requiredRules"
                                            >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex  hide-details mx-4 xs3>
                                        <v-text-field
                                            v-model="user.LastName"
                                            label="Last Name"
                                            single-line
                                            clearable
                                            :rules="requiredRules"
                                            >
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex hide-details mx-4 xs3>
                                        <v-checkbox 
                                            label="Enabled" 
                                            v-model="user.IsEnabled"
                                            >
                                        </v-checkbox>    
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                            <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                                <v-layout hide-details justify-start row mt-0 mb-0>
                                    <div class="text-xs-left" style="font-size: 20px; font-weight: 600;">
                                        Roles
                                    </div>
                                </v-layout>
                            </v-layout>
                            <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
                                <v-layout hide-details justify-start row mt-0 mb-0>
                                    <v-flex  hide-details mx-4 xs3>
                                        <v-checkbox label="AR" v-model="user.ArRole"></v-checkbox>
                                    </v-flex>
                                    <v-flex  hide-details mx-4 xs3>
                                        <v-checkbox label="User Admin" v-model="user.UserAdminRole"></v-checkbox>
                                    </v-flex>
                                    <v-flex  hide-details mx-4 xs3>
                                        <v-checkbox label="BOSS40 Admin" v-model="user.BOSS40AdminRole"></v-checkbox>
                                    </v-flex>
                                    <v-flex hide-details mx-4 xs3 align-end>
                                        <v-btn color="success"
                                                ml-2 mr-4 align-end
                                                @click="createUser">
                                            {{ formType == "create" ? "Create New" : "Save" }}
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-form>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-card>
    </v-flex>
</template>

<script>
import Spinner from '../../components/Spinner.vue';
import axios from "axios";
import Bus from "../../bus";
import moment from 'moment';
import zigZag from '../../components/ZigZag';

export default {
    name: "CreateUser",

    components: {
        Spinner,
        zigZag
    },

    data: () => ({
        dialog: false,
        valid: true,

        requiredRules: [v => !!v || "Required"],
        emailRules: [ 
            v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
        ],

        isUsernameDisabled: false,
        user: {},
        formType: null,
    }),

    mounted() {

    },

    methods: {
        async open(item){
            this.dialog = true;
            this.formType = "create";
        },

        async openEdit(item){
            this.dialog = true;
            this.formType = "edit";

            this.user = item;
            this.isUsernameDisabled = true;
        },

        cancel() {
            this.user = {};
            this.dialog = false;
        },
        close() {
            this.user = {};
            this.dialog = false;
            //this.$emit("parentInitialize");
        },

        async createUser(){
            if(this.$refs.createUserForm.validate()){
                let result = await this.saveUserToDB();

                if (result) {
                    var message

                    if(this.formType=='create'){
                        message="New User Created Successfully!";
                    }
                    else if(this.formType='edit'){
                        message="User Changed Successfully!";
                    }

                    Bus.$emit("alert", {
                        color: "success",
                        message: message
                    });

                    this.close();
                    this.$emit("parentRefresh");
                }
            }
        },

        async saveUserToDB(){
            var result
            var url

            if(this.formType==='create'){
                url = 'api/User/Create';
            }
            else if(this.formType==='edit'){
                console.log('Update User');
                url = 'api/User/Update';
            }
            else{
                return false;
            }

            result = await axios.post(url,this.user)
                .catch(error => {
                    console.log(error);
                });

            return result;
        },
    },
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>
